
import * as api from "../constant/NewAPI";
import { Column } from "primereact/column";
import { DataTable } from "primereact/datatable";
import React, { useEffect, useRef, useState } from "react";
import Select from "react-select";
import { Link } from "react-router-dom";
import Utils from "../constant/Utils";
import { Button, Modal, ModalBody, ModalFooter, ModalHeader, ModalTitle } from "react-bootstrap";
import Swal from "sweetalert2";

// import * as api from "../constant/API";

const ProductCategory = () => {

    const [searchInput, setSearchInput] = useState("");
    const [categoryList, setCategoryList] = useState([]);
    const [sportList, setSportList] = useState([]);
    const [catSportId, setCatSportId] = useState("");
    const [catName, setCatName] = useState("");
    const [catDescription, setCatDescription] = useState("");
    const [rowId, setRowId] = useState("");
    const [error, setError] = useState("");
    const [nameError, setNameError] = useState("");
    const [descriptionError, setDescriptionError] = useState("");
    const [openModal, setOpenModal] = useState(false);
    const [isEdit, setIsEdit] = useState(false);

    const formRef = useRef(null);

    const roleId = localStorage.getItem('RoleId');

    useEffect(() => {
        prodCategoryList();
        sportsList();
    }, [])

    function prodCategoryList() {
        const getCategoryList = api.CategoryList;
        fetch(getCategoryList, {
            method: "GET",
            headers: {
                "Content-Type": "application/json",
                "Authorization": 'Bearer ' + Utils.getAccessToken()
            }
        })
            .then((catResponse) => catResponse.json())
            .then((catResult) => {
                if (catResult.code == 401) {
                    Utils.logoutUser();
                } else if (catResult.error == true) {
                    Swal.fire(catResult.message)
                } else {
                    setCategoryList(catResult.data)
                }
            })
            .catch((error) => {
                console.log("Failed to fetch product category list", error)
            })
    }

    function sportsList() {
        const getSportsList = api.InventorySportList;
        fetch(getSportsList, {
            method: "GET",
            headers: {
                "Content-Type": "application/json",
                "Authorization": 'Bearer ' + Utils.getAccessToken()
            }
        })
            .then((sprtResponse) => sprtResponse.json())
            .then((sprtResult) => {
                if (sprtResult.code == 401) {
                    Utils.logoutUser();
                }
                setSportList(sprtResult.data)
            })
    }

    const filteredData = categoryList.filter((datas) => {
        const values = Object.values(datas).map((value) =>
            value !== null && value !== undefined ? value.toString().toLowerCase() : '');
        return values.some((value) => value.includes(searchInput.toLowerCase()));
    });


    const editDetails = (rowData) => {
        return (
            <Link to="#" onClick={() => editCat(rowData)}>
                <i className="feather-edit" />
                Edit
            </Link>
        );
    };

    const slNoRender = (rowData, column) => {
        return column.rowIndex + 1;
    };

    const nameRender = (rowData) => {
        return <span>{rowData.productCategoryName}</span>;
    };

    const sportRender = (rowData) => {
        return <span>{rowData.sportName}</span>
    };

    function editCat(selectedRow) {
        const sportId = selectedRow.productCategorySportId;
        const name = selectedRow.productCategoryName;
        const description = selectedRow.productCategoryDescription;
        const row = selectedRow.productCategoryId;
        setCatSportId(sportId);
        setCatName(name);
        setCatDescription(description);
        setRowId(row);

        setIsEdit(true)
        setOpenModal(true)
    }

    function initial() {
        setCatSportId('');
        setCatName('');
        setCatDescription('');
    }

    function createCategory(e) {
        e.preventDefault();
        if (!formRef.current.checkValidity()) {
            formRef.current.reportValidity();
        } else {
            if (isEdit) {
                updateCategory();
            }
            else {
                if (!catSportId) {
                    setError("Select Sport");
                }
                else if (!catName) {
                    setNameError("Product Category Name Required")
                }
                else if (!catDescription) {
                    setDescriptionError("Product Category Description Required");
                }

                const formData = new FormData();
                formData.append("catName", catName);
                formData.append("catSports", catSportId);
                formData.append("catDesc", catDescription);

                const createCategory = api.CategoryCreate;

                fetch(createCategory, {
                    method: "POST",
                    body: formData,
                    headers: {
                        "Authorization": 'Bearer ' + Utils.getAccessToken()
                    }
                })
                    .then((createResponse) => createResponse.json())
                    .then((result) => {
                        if (result.error == false) {
                            Swal.fire({
                                title: 'Success',
                                text: result.message,
                                confirmButtonText: 'OK',
                                allowOutsideClick: false,
                                allowEscapeKey: false
                            }).then((res) => {
                                if (res.isConfirmed) {
                                    window.location.reload(); // 🔁 Reload only after OK is clicked
                                }
                            });
                        } else {
                            if (result.code == 401) {
                                Utils.logoutUser();
                            }
                            Swal.fire({
                                title: 'Error',
                                text: result.message,
                                confirmButtonText: 'OK',
                                allowOutsideClick: false,
                                allowEscapeKey: false
                            }).then((res) => {
                                if (res.isConfirmed) {
                                    window.location.reload(); // 🔁 Reload only after OK is clicked
                                }
                            });
                        }
                    })
                    .catch((error) => {
                        console.log("Failed to create new Category", error);
                    })
            }
            setOpenModal(false);
        }
    }

    function updateCategory() {
        const formData = new FormData();
        formData.append('catName', catName);
        formData.append('catSports', catSportId);
        formData.append('catDesc', catDescription);
        formData.append('catId', rowId);

        const update = api.UpdateCategory;
        fetch(update, {
            method: "POST",
            body: formData,
            headers: {
                "Authorization": 'Bearer ' + Utils.getAccessToken()
            }
        })
            .then((updateResponse) => updateResponse.json())
            .then((result) => {
                if (result.error == false) {
                    Swal.fire({
                        title: 'Success',
                        text: result.message,
                        confirmButtonText: 'OK',
                        allowOutsideClick: false,
                        allowEscapeKey: false
                    }).then((res) => {
                        if (res.isConfirmed) {
                            window.location.reload(); // 🔁 Reload only after OK is clicked
                        }
                    });
                } else {
                    if (result.code == 401) {
                        Utils.logoutUser();
                    }
                    Swal.fire({
                        title: 'Error',
                        text: result.message,
                        confirmButtonText: 'OK',
                        allowOutsideClick: false,
                        allowEscapeKey: false
                    }).then((res) => {
                        if (res.isConfirmed) {
                            window.location.reload(); // 🔁 Reload only after OK is clicked
                        }
                    });
                }
            })
            .catch((error) => {
                console.log("Failed to update category", error);
            })
    }

    return (
        <>
            <div className="row">
                <div className="col-sm-12">
                    <div className="court-tab-content">
                        <div className="card card-tableset">
                            <div className="card-body">
                                <div className="coache-head-blk">
                                    <div className="row align-items-center">
                                        {roleId == '1' || roleId == '3' || roleId == '5' ? (
                                            <>
                                                <div className="row col-lg-12">
                                                    <div className="save-changes">
                                                        <Button
                                                            className="btn-secondary text-uppercase"
                                                            variant="success"
                                                            onClick={() => { setOpenModal(true); setIsEdit(false); initial(); }}
                                                        >
                                                            <i className="fas fa-share">Add Category</i>
                                                        </Button>
                                                    </div>
                                                </div>
                                            </>
                                        ) : null}
                                        <div className="col-lg-6">
                                        </div>
                                        <div className="col-lg-6">
                                            <div className="dataTables_filter">
                                                <label>
                                                    <input
                                                        type="text"
                                                        value={searchInput}
                                                        onChange={(e) => setSearchInput(e.target.value)}
                                                        placeholder="Search"
                                                        className="form-control"
                                                    />
                                                </label>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                <div className="tab-content">
                                    <div
                                        className="tab-pane fade show active"
                                        id="nav-Recent"
                                        role="tabpanel"
                                        aria-labelledby="nav-Recent-tab"
                                        tabIndex={0}
                                    >
                                        <div className="table-responsive table-datatble">
                                            <DataTable
                                                className="table datatable"
                                                value={filteredData}
                                                paginator
                                                rows={10}
                                                rowsPerPageOptions={[10, 25, 50]}
                                                currentPageReportTemplate="{first}- {last} of {totalRecords} entries"
                                            >
                                                <Column
                                                    sortable
                                                    headerClassName="text-uppercase"
                                                    field="slno"
                                                    header="Sl No"
                                                    body={slNoRender}
                                                ></Column>
                                                <Column
                                                    sortable
                                                    headerClassName="text-uppercase"
                                                    field="productCategoryName"
                                                    header="Category Name"
                                                    body={nameRender}
                                                ></Column>
                                                <Column
                                                    sortable
                                                    headerClassName="text-uppercase"
                                                    field="sportName"
                                                    header="Sport"
                                                    body={sportRender}
                                                ></Column>
                                                {(roleId == '1' || roleId == '3') ? (
                                                    <Column
                                                        body={editDetails}
                                                    ></Column>
                                                ) : null}
                                            </DataTable>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>

            <Modal
                show={openModal}
                size="md"
                centered
                onHide={() => setOpenModal(false)}
            >
                <ModalHeader>
                    <ModalTitle>
                        <h4 className="mb-0 text-uppercase"><i className="fas fa-truck" />Product Category {isEdit ? "Edit" : ''}</h4>
                    </ModalTitle>
                    <Button
                        variant=""
                        className="btn-close"
                        onClick={() => setOpenModal(false)}
                    ></Button>
                </ModalHeader>
                <ModalBody>
                    <form ref={formRef}>
                        <div className="col-lg-12">
                            <label className="form-label">Sport</label>
                            <Select
                                required
                                value={sportList.find(sprt => sprt.sportId === catSportId) ? {
                                    value: catSportId,
                                    label: sportList.find(sprt => sprt.sportId === catSportId).sportName
                                } : null}
                                onChange={(e) => {
                                    setCatSportId(e.value);
                                    setError("");
                                }}
                                placeholder="Select Sport"
                                options={sportList.map(sprt => ({
                                    value: sprt.sportId,
                                    label: sprt.sportName
                                }))}>
                            </Select>
                            {error && <div className="alert alert-danger">{error}</div>}
                        </div>
                        <div className="col-lg-12">
                            <label className="form-label">Product Category Name</label>
                            <input
                                id="batchName"
                                className="form-control"
                                style={{ border: "1px solid hsl(0, 0%, 80%)" }}
                                value={catName}
                                required
                                onChange={(e) => {
                                    setCatName(e.target.value)
                                    setNameError("");
                                }}
                            />
                            {nameError && <div className="alert alert-danger">{nameError}</div>}
                        </div>
                        <div className="col-lg-12">
                            <label className="form-label">Product Category Description</label>
                            <input
                                id="batchDescription"
                                className="form-control"
                                style={{ border: "1px solid hsl(0, 0%, 80%)" }}
                                value={catDescription}
                                required
                                onChange={(e) => {
                                    setCatDescription(e.target.value)
                                    setDescriptionError("")
                                }}
                            />
                            {descriptionError && <div className="alert alert-danger">{descriptionError}</div>}
                        </div>
                    </form>
                </ModalBody>
                <ModalFooter>
                    <Button
                        className="btn-primary text-uppercase"
                        variant="success"
                        onClick={createCategory}
                        data-bs-dismiss="modal" aria-label="Close"
                    >
                        <b><i className="fas fa-save" />{isEdit ? " Update" : " Save"}</b>
                    </Button>
                </ModalFooter>
            </Modal>
        </>
    );
};

export default ProductCategory;